import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import instance from "../../services/endpoint";
import '../../styles/clicktoverify.css';
import { toast } from "react-toastify";


const AdminEmailVerify = ({ show, handleClose }) => {
    const { emailVerifyToken } = useParams(); // Get token from URL params
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [error, setError] = useState(null);
  const [hasRequested, setHasRequested] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    setLoading(true);
    setIsLoading(true);
    if (emailVerifyToken) {
      try {
        setLoading(true);
        const response = await instance.post(
          `/api/v1/admin/auth/verifyEmail/${emailVerifyToken}`,
          {},
          { withCredentials: true }
        );
        toast.success("Email Verified Successfully")
        setIsVerified(true);
        // setTimeout(() => navigate("/login"), 5000); // Redirect to login after success
      } catch (err) {
        setError(err.response?.data?.message || "Verification failed. Please try again and ensure you verify this using the same browser where you attempted to login.");
        toast.error(err.response?.data?.message || "Verification failed. Please try again.");
        setIsLoading(false);
      } finally {
        setLoading(false);
        setHasRequested(true);
      }
    }
  };

  useEffect(() => {
    if (isVerified) {
      setTimeout(() => navigate("/adminlogin"), 4000); // Redirect to login after success
    }
  }, [isVerified, navigate]);

  return (
    <>
     {!hasRequested ? (
       <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="p-4">
        <Modal.Title className="text-center mb-4">
          <h3>Email Verification</h3>
        </Modal.Title>

        <Form>
          <Button
            variant="primary"
            className="w-100 mb-3"
            onClick={handleVerify}
            style={{
              borderRadius: "20px",
              background: "#d4af37",
              border: "none",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#e5c100")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#ffd700")}
            >
              {loading ?  <Spinner animation="border" className="d-block mx-auto" /> : "Verify Email"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
     )  : (
      <>
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Body className="p-4">
            <Modal.Title className="text-center mb-4">
            {isLoading && <h3>Email Verification</h3>}
            </Modal.Title>
            {isVerified && (
               <Modal.Title className="text-center mb-4">
                Your email has been verified successfully! Redirecting to login...
                </Modal.Title>
            )}
            <Modal.Title className="text-center mb-4">
            {error && <p className="email-verification-error">{error}</p>}
            </Modal.Title>
          </Modal.Body>
        </Modal> 
      </>
    )}
  </>   
  );
};

export default AdminEmailVerify;